// extracted by mini-css-extract-plugin
export var header = "Header-module--header--1Qt4T";
export var transparent = "Header-module--transparent--2KWgm";
export var header__nav = "Header-module--header__nav--2ltdu";
export var header__nav__brand = "Header-module--header__nav__brand--1Cq8d";